import * as React from 'react';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import { isDisabled } from '../utils/customPropStyles';
import Translate, { translate } from './Translate';
import Icon from './Icon';
import { IconAlignment } from '../types';
import { TranslationStore, AccessibilityStore } from '../stores';
import { computed } from 'mobx';
import { Buttons } from '../models/configuration/accessibility/buttons';
import { Theme } from '../models/Theme';

const Button = styled<any, any>('button', 'button', 'paginationButton')`
    ${propStyles};
    ${isDisabled};
`;

Button.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    padding: 'xs',
    fontFamily: 'body',
    fontWeight: 'normal',
    fontSize: 'sm',
    color: 'body',
    bgColor: 'transparent',
    borderStyle: 'none',
    cursor: 'pointer',
    selected: {
        color: 'body',
    },
    isDisabled: {
        color: 'gray500',
    },
};
interface PaginationButtonProps {
    label: string;
    showLabel?: boolean;
    onClick: () => void;
    iconFileName?: string;
    iconAlignment?: IconAlignment;
    buttonAccessibilityValueKey?: keyof Buttons;
    iconAccessibilityValueKey?: keyof Buttons;
    ariaLabelPlaceholders?: AriaLabelPlaceholders;
    translationStore?: TranslationStore;
    accessibilityStore?: AccessibilityStore;
    theme?: Theme;
    disabled?: boolean;
}

export interface AriaLabelPlaceholders {
    prev: number;
    next: number;
    total: number;
}

@inject('accessibilityStore', 'translationStore')
@observer
class PaginationButton extends React.Component<PaginationButtonProps> {
    @computed
    get buttonAriaLabel(): string {
        const {
            accessibilityStore,
            buttonAccessibilityValueKey,
            ariaLabelPlaceholders,
        } = this.props;
        return accessibilityStore.buttonAccessibilityValue(
            buttonAccessibilityValueKey,
            'Page {prev} to {next} of {total}',
            ariaLabelPlaceholders
        );
    }

    @computed
    get iconAriaLabel(): string {
        const { accessibilityStore, iconAccessibilityValueKey } = this.props;
        return accessibilityStore.buttonAccessibilityValue(
            iconAccessibilityValueKey,
            'PaginationButtonIcon'
        );
    }

    @computed
    get title(): string {
        const { label = '', translationStore } = this.props;
        return translate(translationStore, label);
    }

    @computed
    get icon(): React.ReactNode {
        const { iconFileName, theme } = this.props;
        if (iconFileName) {
            return (
                <Icon
                    height="1.4em"
                    width="1.4em"
                    fileName={iconFileName}
                    aria-label={this.iconAriaLabel}
                    {...theme.PaginationButtonIcon}
                />
            );
        }

        return null;
    }

    render() {
        const {
            label,
            showLabel,
            onClick,
            iconAlignment = 'right',
            theme,
            ...props
        } = this.props;
        return (
            <Button
                title={this.title}
                aria-label={this.buttonAriaLabel}
                onClick={onClick}
                data-metric-id={'paginationNavigation-button'}
                {...theme.PaginationButton}
                {...props}
            >
                {iconAlignment === 'left' && this.icon}
                {showLabel && <Translate>{label}</Translate>}
                {iconAlignment === 'right' && this.icon}
            </Button>
        );
    }
}

export default withTheme(PaginationButton);



// WEBPACK FOOTER //
// ./src/Components/PaginationButton.tsx